//@ts-nocheck
import React from "react";

const RepeatOrder = () => {
  return <div>RepeatOrder</div>;
};

export default RepeatOrder;
